import { Pessoa } from '@tivic-team/manager-ts/dist/grl';
import { Concessao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity';
import { Linha } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha.entity';
import { Parada } from '@tivic-team/manager-ts/dist/mob/entities/parada/parada.entity';

export class LinhaDTO extends Linha {

    parada: Parada = void(0)
    concessao: Concessao = void(0);
    concessionario: Pessoa = void(0);
    
    constructor() {
        super();
    }

}

export class LinhaListDTO {
    items: Array<LinhaDTO>;
    total: number;
    constructor() {}
}